import { render, staticRenderFns } from "./WorkspaceMenubar.vue?vue&type=template&id=08989f5f&scoped=true&"
import script from "./WorkspaceMenubar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceMenubar.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceMenubar.vue?vue&type=style&index=0&id=08989f5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08989f5f",
  null
  
)

export default component.exports